module.exports = __webpack_public_path__ + "static/media/bagWithScheme.dc191391.svg";